/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;
const SvgCheckboxOn = (props: Props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12Zm-2.239 3.894-5.513 5.52-2.01-2.012L3 8.642l3.248 3.252L13 5.134l-1.239-1.24Z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCheckboxOn as CheckboxOn };
